<template>
<div>
  <app-header title="メールがとどかない場合" />
  <div class="container">
    <typo-label type="2" class="header-2">PCメールの場合</typo-label>
    <ul class="top-list">
      <li class="top-list-item">
        <div class="subject"><typo-label type="text-2" bold="true">迷惑メールフォルダの確認</typo-label></div>
        <div class="detail"><typo-label type="text-2">メールサービスによっては何も設定していない場合でも、自動的に迷惑メール扱いになっている場合があります。</typo-label></div>
      </li>
      <li class="top-list-item">
        <div class="subject"><typo-label type="text-2" bold="true">なりすましメール拒否設定の確認</typo-label></div>
        <div class="detail"><typo-label type="text-2">設定を解除するか、@<span style="color:red">farmnote.info</span>からの受信を許可してください。</typo-label></div>
      </li>
    </ul>
    <typo-label type="2" class="header-2">携帯メールの場合</typo-label>
    <ul class="top-list">
      <li class="top-list-item">
        <div class="subject"><typo-label type="text-2" bold="true">ドメイン指定受信の確認</typo-label></div>
        <div class="detail"><typo-label type="text-2">@<span style="color:red">farmnote.info</span>からの受信を許可してください。(ドメインとはメールアドレスの@より右側の部分です。)</typo-label></div>
      </li>
      <li class="top-list-item">
        <div class="subject"><typo-label type="text-2" bold="true">URLつきメール受信拒否設定の確認</typo-label></div>
        <div class="detail"><typo-label type="text-2">「https://」からはじまるインターネットのアドレスが含まれたメールを受信できる設定へ変更してください。</typo-label></div>
        </li>
      <li class="top-list-item">
        <div class="subject"><typo-label type="text-2" bold="true">PCからのメール受信設定の確認</typo-label></div>
        <div class="detail"><typo-label type="text-2">PCからのメールを受信できるように設定を変更してください。</typo-label></div>
      </li>
      <li class="top-list-item">
        <div class="subject"><typo-label type="text-2" bold="true">携帯電話各社の迷惑メール設定の確認方法</typo-label></div>
        <div class="detail">
          <ul class="middle-list">
            <li><a href="https://www.nttdocomo.co.jp/info/spam_mail/index.html" target="blank">docomo</a></li>
            <li><a href="https://www.softbank.jp/mobile/support/antispam/settings/" target="blank">Softbank</a></li>
            <li><a href="https://www.au.com/support/service/mobile/trouble/mail/email/filter/" target="blank">au</a></li>
            <li><a href="http://www.ymobile.jp/service/others/spam/" target="blank">Y!mobile</a></li>
          </ul>
        </div>
      </li>
    </ul>
    <typo-label type="2" class="header-2">現在Farmnoteを利用してるか以前Farmnoteを利用していた場合</typo-label>
    <ul class="top-list">
      <li class="top-list-item"><typo-label type="text-2">現在Farmnoteを利用している場合は、アカウント登録せずにログインしてください。</typo-label></li>
      <li class="top-list-item"><typo-label type="text-2">以前Farmnoteのトライアルをお試しいただいた方はこちらではアカウント発行されません。<a href="https://farmnote.jp/inquiry.html">こちら</a>にお問い合わせください。</typo-label></li>
    </ul>
  </div>
</div>
</template>

<script>
import AppHeader from './AppHeader'
export default {
    components: { AppHeader }
}
</script>

<style scoped>
.container {
  padding: 16px;
}
.header-2 {
  margin-bottom: 24px;
  display: block;
}
.top-list {
  margin: 0 0 48px;
  list-style-type: none;
  padding: 0 0 0 16px;
  box-sizing: border-box;
}

.top-list-item {
  margin-bottom: 24px;
}

.subject {
  margin-bottom: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/CarrierEmailSettings.vue